export default "__VITE_ASSET__ceDlVi5x__"